import React, { useEffect, useRef, useState, useCallback, memo } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Invoices.css";
import { FaEllipsisV } from "react-icons/fa";
import { deleteinvoice } from "../../services/invoiceService";
import Swal from "sweetalert2";
import { getErrorMessage } from "../../services/errorHelper";
import apiClient, { getCurrentUserId } from "../../services/apiClient";

function Invoices() {
  const [Invoices, setInvoices] = useState([]);
  const [selectedEmail, setSelectedEmail] = useState(null);
  const [menuVisible, setMenuVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchInvoices = async () => {
      try {
        const response = await apiClient.post('/invoices_list', { user_id: getCurrentUserId() });
        setInvoices(response.data);
      } catch (error) {
        console.error("Error fetching invoices:", error);
      }
    };
    fetchInvoices();
  }, []);

  const handleEdit = useCallback((emailId) => {
    navigate(`/edit-invoice/${emailId}`);
  }, [navigate]);


  const handleDelete = async (contractId) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
          customClass: {
        popup: 'swal-top-zindex'
      }
      });

      if (result.isConfirmed) {
        await deleteinvoice(contractId);
        setInvoices(Invoices.filter((contract) => contract.id !== contractId));
        Swal.fire("Deleted!", "Invoice has been deleted.", "success");
        //handleProductContentChange("Untitled Item");
      }
    } catch (error) {
      console.error(`Failed to delete Invoice with ID ${contractId}:`, error);
      Swal.fire("Error", getErrorMessage(error, "Failed to delete Invoice."), "error");
    }
  };
  const toggleMenu = (email) => {
    setSelectedEmail(email);
    setMenuVisible(!menuVisible);
  };
  // The return statement contains the JSX code which is rendered and displayed on the page
  return (
    //  ================= *****  INVOICE TEMPLATES BODY JSX ***** =================
    <>
      <div className='container-fluid  p-lg-5 p-md-5 p-3'>
         <div className='row g-lg-5 g-md-5 g-3'>
            <div className='col-sm-12 col-md-12 col-xl-12'>
            {/* Invoice Templates Description about this page */}
            <div className='mb-4'>
              <h3 className='mb-1'>Invoice Templates</h3>
              <p >
                Product templates save time by streamlining the integration of
                individual items into various
                <br /> documents like brochures, invoices, and proposals,
                enabling efficient generation of consistent and
                <br />
                professional-looking files without starting from scratch for
                each new product.
              </p>
            </div>
          </div>
          {/* ========= Create a New Invoice Button ========= */}
          <div id='' className='col-sm-12 col-md-6 col-xl-4 invoice-items'>
            <div className='h-100 bg-white rounded p-3 shadow-sm'>
              <Link
                to='/create-invoice'
                id=''
                className='h-100 d-flex align-items-center justify-content-center px-2 py-5 p-urls'
                style={{ border: "1px dashed #534dbb" }}>
                <div className='mb-4 text-center create-invoice-btn'>
                  <i className='fa-solid fa-plus'></i>
                  <p className='mb-0 fw-light text-uppercase create-invoice-text'>
                    CREATE A <br /> NEW INVOICE
                  </p>
                </div>
              </Link>
            </div>
          </div>
          {/* ========= Firefly - 2 Hour Invoice Button ========= */}
          {Invoices.map((Invoice) => (
            <div key={Invoice.id} id='' className='col-sm-12 col-md-6 col-xl-4 invoice-items'>
              <div className='h-100 bg-white d-flex align-items-center justify-content-center rounded p-4 shadow-sm position-relative' onClick={() => handleEdit(Invoice.id)}>
                <div className='three-dot-btn'>
                  <div className='position-absolute top-0 end-0 me-3 mt-2'>
                    <button className='border-0 bg-transparent ' type='button'>
                      <div id='p-dot' style={{ position: "relative", zIndex: 10000 }} onMouseEnter={() => toggleMenu(Invoice)}
  onMouseLeave={() => toggleMenu(null)}>
                        <FaEllipsisV
                          
                          style={{ cursor: "pointer" }}
                        />
                        {menuVisible && selectedEmail === Invoice && (
                          <div
                            className='position-absolute bg-white shadow-sm rounded'
                            style={{
                              top: "20px",
                              right: "0",
                              zIndex: "10",
                            }}>
                            <button
                              className='dropdown-item'
                              onClick={() => handleEdit(Invoice.id)}>
                              Edit
                            </button>
                            <button
                              className='dropdown-item'
                              onClick={(e) => {
                                e.stopPropagation();
                                handleDelete(Invoice.id)
                              }
                              }>
                              Delete
                            </button>
                          </div>
                        )}
                      </div>
                    </button>
                  </div>
                  <div className='text-center edit-btn'>
                    {/* File With Signature Icon */}

                    <button className='border-0 bg-transparent' type='button'>
                      <i className='fa-solid fa-file-signature'></i>
                    </button>
                    <p className='firefly-invoice'>{Invoice.title.toUpperCase()}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>

    //  ================= *****  INVOICE TEMPLATES BODY JSX ***** =================
  );
}

export default memo(Invoices);
